import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import UnauthorizedNavbar from './UnauthorizedNavbar';

const UnauthorizedLayoutRoot = styled('div')(
  () => ({
    backgroundColor: "#d8d8d8",
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

const UnauthorizedLayoutWrapper = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 64
});

const UnauthorizedLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const UnauthorizedLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const UnauthorizedLayout = () => (
  <UnauthorizedLayoutRoot>
    <UnauthorizedNavbar />
    <UnauthorizedLayoutWrapper>
      <UnauthorizedLayoutContainer>
        <UnauthorizedLayoutContent>
          <Outlet />
        </UnauthorizedLayoutContent>
      </UnauthorizedLayoutContainer>
    </UnauthorizedLayoutWrapper>
  </UnauthorizedLayoutRoot>
);

export default UnauthorizedLayout;
